import React from "react"
import { Box, LinearProgress, Typography } from "@mui/material"
import { resolveViraPalette } from "../theme/resolveViraPalette"

export type LoadingBarProps = {
  label?: string
  value?: number
  /** Indeterminate when value is undefined */
  sx?: object
}

export function LoadingBar({
  label = "Writing your prep",
  value,
  sx,
}: LoadingBarProps) {
  return (
    <Box sx={{ width: "100%", ...sx }}>
      {label ? (
        <Typography
          variant="body2"
          sx={(theme) => ({
            mb: 1,
            color: resolveViraPalette(theme).muted,
            fontWeight: 500,
          })}
        >
          {label}
        </Typography>
      ) : null}
      <LinearProgress
        variant={value == null ? "indeterminate" : "determinate"}
        value={value}
        sx={(theme) => ({
          height: 6,
          borderRadius: 3,
          backgroundColor: resolveViraPalette(theme).lavender,
          "& .MuiLinearProgress-bar": {
            backgroundColor: resolveViraPalette(theme).accent,
            borderRadius: 3,
          },
        })}
      />
    </Box>
  )
}
